import { render, staticRenderFns } from "./reisefinder-view.vue?vue&type=template&id=f20f60b4&scoped=true"
import script from "./reisefinder-view.vue?vue&type=script&lang=js"
export * from "./reisefinder-view.vue?vue&type=script&lang=js"
import style0 from "./reisefinder-view.vue?vue&type=style&index=0&id=f20f60b4&prod&lang=scss&scoped=true"
import style1 from "./reisefinder-view.vue?vue&type=style&index=1&id=f20f60b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20f60b4",
  null
  
)

export default component.exports